import { allOf, anyOf, userMeetsPermission } from './page-permission';
import {
    AppPageCategory,
    AppPageDefinition,
    AvailableAppPageCategory,
    PagePermission,
} from './page.types';

function page(name: string, path: string, permission: PagePermission = null): AppPageDefinition {
    return { name, path, permission };
}

/** Каталог страниц для блока `link`. Новый экран — запись сюда. */
export const APP_PAGE_CATALOG: readonly AppPageCategory[] = [
    {
        title: 'Заявки',
        pages: [
            page('Реестр заявок', '/core/orders', 'ORDERS'),
            page('Редактирование заявки (light)', '/core/orders/{ID}/light', anyOf('ORDERS_CREATE', 'ORDERS_EDIT')),
            page('Отчёт по заявке', '/core/spa2#/cynteka-desktop/orders/{ID}/report', 'ORDERS'),
            page('Заявка из бюджета', '/core/spa2#/cynteka-desktop/projects/{ID}/budget/order', 'BUDGET'),
            page('Заявка из бюджета по шаблону', '/core/spa2#/cynteka-desktop/projects/{ID}/template/{ID}/make/order', 'BUDGET'),
        ],
    },
    {
        title: 'Счета',
        pages: [
            page('Реестр счетов', '/core/offers', 'OFFERS'),
            page('Реестр прихода', '/core/offers/incoming', allOf('OFFERS', 'OFFERS_INCOMING')),
            page('Реестр расхода', '/core/offers/outgoing', allOf('OFFERS', 'OFFERS_OUTGOING')),
            page('Реестр трансферов', '/core/offers/transfers', allOf('OFFERS', 'OFFERS_TRANSFERS')),
            page('Отчёт по счёту', '/core/offers/{ID}/report', 'OFFERS'),
            page('Платежи по счёту', '/core/offers/{ID}/payments', anyOf('OFFERS_PLAN_PAY', 'OFFERS_PLAN_PAY_WITHOUT_NOTIFICATIONS')),
            page('Документы счёта', '/core/offers/{ID}/documents', 'OFFERS_DOCUMENTS'),
        ],
    },
    {
        title: 'Прочее',
        pages: [
            page('Товарная база (реестр)', '/core/spa#/goodbase/registry', 'GOOD_BASE_REGISTRY'),
        ],
    },
    {
        title: 'Доставки',
        pages: [
            page('Реестр доставок', '/core/spa2#/cynteka-desktop/delivery-registry'),
            page('Отчёт по доставке', '/core/spa#/deliveries/{ID}/report'),
            page('Приёмка доставки', '/core/spa#/deliveries/{ID}/accept'),
            page('Редактирование доставки', '/core/spa#/deliveries/{ID}/edit', 'DELIVERIES_EDIT'),
            page('Перемещение доставки', '/core/spa#/deliveries/{ID}/return'),
            page('Планирование доставки', '/core/spa#/offers/{ID}/delivery/plan'),
        ],
    },
    {
        title: 'Проекты и бюджеты',
        pages: [
            page('Реестр проектов', '/core/refbooks/projects', 'REFBOOKS_PROJECTS'),
            page('Карточка проекта (общая информация)', '/core/spa2#/cynteka-desktop/project/report/{ID}/common', 'REFBOOKS_PROJECTS'),
            page('Проект: ответственные', '/core/spa2#/cynteka-desktop/project/report/{ID}/responsibles', 'REFBOOKS_PROJECTS'),
            page('Проект: ответственные ЭДО', '/core/spa2#/cynteka-desktop/project/report/{ID}/ediresponsibles', allOf('REFBOOKS_PROJECTS', 'EDI_RESPONSIBLE_EDITOR')),
            page('Проект: адреса', '/core/spa2#/cynteka-desktop/project/report/{ID}/spots', 'REFBOOKS_PROJECTS'),
            page('Проект: бюджеты', '/core/spa2#/cynteka-desktop/project/report/{ID}/budgets', anyOf('REFBOOKS_PROJECTS_BUDGETS', 'REFBOOKS_PROJECTS_BUDGETS_VIEW')),
            page('Редактор бюджета', '/core/spa#/projects/{ID}/budgets/{ID}', 'BUDGET'),
            page('Новый бюджет', '/core/spa#/projects/{ID}/budgets/new', 'BUDGET'),
            page('Клонирование бюджета', '/core/spa#/projects/{ID}/budgets/{ID}/clone', 'BUDGET'),
            page('Заявка из бюджета (SPA)', '/core/spa#/projects/{ID}/budgets/{ID}/makeorder', 'BUDGET'),
            page('Отчёт по бюджету', '/core/spa#/projects/{ID}/budgets/{ID}/report', 'BUDGET'),
            page('Дерево бюджетов', '/core/spa#/project/{ID}/budget/tree', 'BUDGET'),
        ],
    },
    {
        title: 'Компании и контакты',
        pages: [
            page('Реестр компаний', '/core/refbooks/companies', 'REFBOOKS_COMPANIES'),
            page('Новая компания (справочник)', '/core/refbooks/companies/new', 'REFBOOKS_COMPANIES_CREATE'),
            page('Карточка компании (SPA)', '/core/spa#/companies/{ID}'),
            page('Документы компании', '/core/spa#/companies/{ID}/documents'),
            page('Лицензии компании', '/core/spa#/companies/{ID}/licenses'),
            page('Адресная книга', '/core/refbooks/contacts', 'REFBOOKS_CONTACTS'),
            page('Новый контакт', '/core/refbooks/contacts/new', 'REFBOOKS_CONTACTS'),
            page('Карточка контакта', '/core/refbooks/contacts/{ID}', 'REFBOOKS_CONTACTS'),
            page('Счета контакта', '/core/refbooks/contacts/{ID}/accounts', 'REFBOOKS_CONTACTS'),
            page('Уведомления контакта', '/core/refbooks/contacts/{ID}/notifications', 'REFBOOKS_CONTACTS'),
            page('Роли контакта', '/core/refbooks/contacts/{ID}/roles', 'REFBOOKS_CONTACTS'),
            page('Условия участия в акцептации', '/core/refbooks/contacts/{ID}/conditions', 'CONDITION_PARTICIPATION_IN_ACCEPTANCE'),
            page('Условный приоритет акцептации', '/core/refbooks/contacts/{ID}/conditionalAcceptPriority', 'CONDITIONAL_ACCEPT_PRIORITY'),
            page('Отпуск контакта', '/core/refbooks/contacts/{ID}/vacation', anyOf('VACATION_CHANGE', 'VACATION_VIEW')),
        ],
    },
    {
        title: 'Уведомления (списки сущностей)',
        pages: [
            page('Согласовать заявки', '/core/notifications/orders', 'ORDERS'),
            page('Передать в работу', '/core/notifications/deferred', 'ORDERS'),
            page('Напоминания по заявкам', '/core/notifications/reminder_orders', 'DEFFERED_ORDERS_CREATE'),
            page('Согласовать счета', '/core/notifications/offers', 'OFFERS'),
            page('Принять доставки', '/core/notifications/apply_deliveries', anyOf('DELIVERIES_NOTIFICATIONS_SHOW', 'DELIVERIES_NOTIFICATIONS_SHOW_FUTURE')),
            page('Запланировать отгрузку', '/core/notifications/confirm_deliveries', 'DELIVERIES'),
            page('Оплатить', '/core/notifications/pay_payments', 'OFFERS_PAY'),
            page('Принять в оплату', '/core/notifications/approve_payments', 'OFFERS_PAY_APPROVE'),
            page('Запланировать платежи', '/core/notifications/confirm_payments', 'OFFERS_PLAN_PAY'),
            page('Согласовать документы счетов', '/core/notifications/accept_documents', 'OFFERS_DOCUMENTS_ACCEPT'),
            page('Просмотреть документы', '/core/notifications/view_documents', 'DOCUMENTS'),
            page('Получить документы', '/core/notifications/required_documents', 'DOCUMENTS'),
            page('Согласовать бюджет', '/core/notifications/budget_accepts', 'BUDGET'),
            page('ЭДО приглашения', '/core/notifications/ediInvites', 'CAN_MANAGE_EDI_INVITES'),
        ],
    },
    {
        title: 'Личный кабинет',
        pages: [
            page('Личные данные', '/core/cabinet/personal'),
            page('Условия участия (кабинет)', '/core/cabinet/personal/conditions', 'CONDITION_PARTICIPATION_IN_ACCEPTANCE'),
            page('Условный приоритет (кабинет)', '/core/cabinet/personal/conditionalAcceptPriority', 'CONDITIONAL_ACCEPT_PRIORITY'),
            page('Отпуск', '/core/cabinet/personal/vacation', anyOf('VACATION_CHANGE', 'VACATION_VIEW')),
            page('Смена пароля', '/core/cabinet/password'),
        ],
    },
    {
        title: 'ЭДО (legacy)',
        pages: [
            page('Реестр ЭДО (старый)', '/core/customer/ediStateRegistry', 'CUSTOMER_EDI_STATE_REGISTRY'),
            page('Документ ЭДО', '/core/customer/ediStates/{ID}'),
            page('Сравнение печатных форм ЭДО', '/core/customer/ediStates/{ID}/compareDocument'),
            page('Верстак приёмки ЭДО', '/core/customer/ediStates/{ID}/acceptance-workbench', 'EDI_STATE_ACCEPTANCE_WORKBENCH'),
            page('Генератор ЭДО (Закупай)', '/core/customer/ediGenerator'),
            page('Генератор ЭДО по счёту (Продавай)', '/core/offers/{ID}/ediGenerator', anyOf('SUPPLIER_EDI_STATE_REGISTRY', 'ZAKUPAY_EDI_GENERATOR')),
            page('Генератор УКД', '/core/supplier/ediStates/{ID}/ukdGenerator', 'SUPPLIER_EDI_STATE_REGISTRY'),
        ],
    },
];

/** Категории, видимые текущему пользователю. Поле permission в ответ не входит. */
export function listAvailablePages(granted: ReadonlySet<string>): AvailableAppPageCategory[] {
    return APP_PAGE_CATALOG
        .map((category) => ({
            title: category.title,
            pages: category.pages
                .filter((item) => userMeetsPermission(item.permission, granted))
                .map(({ name, path }) => ({ name, path })),
        }))
        .filter((category) => category.pages.length > 0);
}
